import React from 'react';
import GlobalStyle from '../assets/global.style';
import SimpleHeader from '../components/SimpleHeader-comp/simpleheader';
import AdvertiserDisclosureContent from '../components/AdvertiserDisclosureContent-comp/advertiserdisclosurecontent';
import Footer from '../components/Footer-comp/footer';


function AdvertiserDisclosure() {
  return (

      <div className="App">
        <GlobalStyle/>
        <SimpleHeader/>
        <AdvertiserDisclosureContent/>
        <Footer/>
      </div>
    
  );
}

export default AdvertiserDisclosure